import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import { Box, Container, Grid } from "@mui/material";
import { BranchItem } from "./BranchItem/BranchItem";
import { branchesData } from "./utils";

export function BranchesWeServe() {
  return (
    <Box component="section" sx={{ paddingY: 8, backgroundColor: "#f5f7fa" }}>
      <Container>
        <SectionTitleAndSubtitle
          title="Ramos que Atendemos"
          subTitle="Nossa experiência abrange diversos segmentos de mercado."
          textAlign="center"
        />
        <Grid container spacing={{ xs: 1, sm: 2, md: 4 }} sx={{ marginTop: 3 }}>
          {branchesData.map((branch) => (
            <BranchItem key={branch.name} name={branch.name} icon={branch.icon} />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
